export const ARTICLE_SLOT_MODEL = {
  GENERAL: {
    Id: '',
    Title: '',
    ExpandedContent: '',
    Slug: '',
    Tldr: '[]',
    PublishedOn: '',
    ModifiedOn: '',
    IsPinned: false,
    IsSessionWrap: false,
    IsMigrated: false,
    Category: {
      Name: '',
      Slug: ''
    },
    Author: {
      Id: '',
      Name: '',
      Slug: '',
      Status: '',
      Role: '',
      PhotoUrl: null
    },
    SponsorshipCompany: null,
    ThumbnailImage: null,
    FeaturedVideo: null,
    Terms: []
  },
  NOTIFICATION: {
    Id: '',
    Article: null,
    DirectoryArticle: null,
    ForexLiveArticle: null,
    Authors: [],
    Tags: [],
    Categories: [],
    Companies: []
  }
}
